<!--<p-tree class="selector" [lazy]="true"  [value]="specTree" selectionMode="checkbox" [loading]="loading" (onNodeExpand)="loadChildren($event.node)" filterPlaceholder="Select specs" display="chip" fluid="true" [propagateSelectionUp]="false" [(ngModel)]="selectedSpecs" placeholder="Select specs"></p-tree>-->
<div class="selector">
  <p-tree
          [value]="specTree"
          [lazy]="true"
          [loading]="loading"
          [loadingMode]="'icon'"
          (onNodeExpand)="loadChildren($event.node)"
          selectionMode="checkbox"
          [(selection)]="selectedSpecs">
  </p-tree>
</div>
@if (selectedSpecs !== undefined && selectedSpecs.length > 0) {
  <p-button class="button p-button-primary" (click)="useSelectedSpecs()">
    @if (loadingSelection) {
      <fa-icon [icon]="faSyncAlt" animation="spin"></fa-icon> Confirm Selection
    } @else {
      <fa-icon [icon]="faCheck"></fa-icon> Confirm Selection
    }
  </p-button>
} @else {
  <p-button class="button p-button-text">
    <fa-icon [icon]="faTimes"></fa-icon> Cancel
  </p-button>
}
